module.exports = __webpack_public_path__ + "img/NY TimeSqure.d90789f2.jpg";